import { isMobileFolder, isPurchasedFolder } from '../../../utils/media-manager-sdk/items';
import {
  isBoards,
  isFavorites,
  isMediaFromWix,
  isShutterstock,
  isSiteFiles,
  isTrash,
  isVisitorsUploads,
} from '../../../utils/media-manager-sdk/sources';
import { RouteMatcher } from '../../../utils/RouteHelpers';
import { EmptyStateType, TGetEmptyStateType } from './EmptyState.types';

export const getEmptyStatesType = ({
  currentFolder,
  source,
  searchQuery,
  isNotAuthorized,
  isUnknownError,
  isNetworkError,
  isOffline,
  isEnterprise,
  location,
}: TGetEmptyStateType): EmptyStateType => {
  if (isOffline) {
    return EmptyStateType.Offline;
  }
  if (isUnknownError) {
    return EmptyStateType.UnknownError;
  }

  if (isNetworkError) {
    return EmptyStateType.NetworkError;
  }

  if (isNotAuthorized) {
    return EmptyStateType.NotAuthorized;
  }

  if (searchQuery && !RouteMatcher.isSearchEverywhere(location.pathname)) {
    return EmptyStateType.SearchBySource;
  }

  if (isSiteFiles(source)) {
    if (isMobileFolder(currentFolder)) {
      return EmptyStateType.Mobile;
    }
    if (isPurchasedFolder(currentFolder)) {
      return EmptyStateType.Purchased;
    }
  }

  if (isTrash(source)) {
    return EmptyStateType.Trash;
  }

  if (isFavorites(source)) {
    return EmptyStateType.Favorites;
  }

  if (isVisitorsUploads(source)) {
    return EmptyStateType.VisitorUploads;
  }

  if (isMediaFromWix(source)) {
    return EmptyStateType.MediaFromWix;
  }

  if (isShutterstock(source)) {
    return EmptyStateType.Shutterstock;
  }

  if (RouteMatcher.isSearchEverywhere(location.pathname)) {
    return EmptyStateType.Search;
  }

  if (isBoards(source)) {
    return EmptyStateType.Board;
  }

  if (isEnterprise) {
    return EmptyStateType.Enterprise;
  }

  return EmptyStateType.SiteFilesNewDnD;
};
